export default {
  methods: {
    /*
     获取根据form中的每个字段创建的table heads
    */
    getTableHeads(fields, slotFlags = []) {
      fields = Array.prototype.concat.apply([], fields);
      return fields.map(({ label, name }) => {
        const head = { label };
        if (slotFlags.includes(name)) {
          head.slotName = name;
        } else {
          head.prop = name;
        }
        return head;
      });
    },

    /*
     获取filter组件的各个字段组成的model
    */
    getFilterModel(fields) {
      fields = Array.prototype.concat.apply([], fields);
      return fields.reduce((memo, { type, name, initVal }) => {
        if (initVal == null) {
          memo[ name ] = new type().valueOf();
        } else if (Object.prototype.toString.call(initVal).slice(8, -1).toLowerCase() === 'object') {
          memo[ name ] = { ...initVal };
        } else {
          memo[ name ] = initVal;
        }
        return memo;
      }, {});
    }
  }
};